import {AnankeLozenge} from "@vesta/ananke/components/anankeLozenge";
import type {JourneyProgressStatus} from "./types";

export function JourneyProgressCardStatusBadge({status}: {status: JourneyProgressStatus}) {
    const isActive = status === "active";

    return (
        <AnankeLozenge appearance={isActive === true ? "success" : "removed"}>
            {isActive === true ? "Active" : "Inactive"}
        </AnankeLozenge>
    );
}
